








import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class BadgeCreditCardThumb extends Vue {
  @Prop(String) readonly cardNumber!: string;
  @Prop(Number) readonly width!: number;

  private bins = [
    { name: 'diners', regexpBin: /^3(?:0[0-5]|[68][0-9])/ },
    { name: 'hipercard', regexpBin: /^3841[046]0|^60/ },
    { name: 'amex', regexpBin: /^3[47]/ },
    { name: 'mastercard', regexpBin: /^5[1-5][0-9][0-9]/ },
    { name: 'visa', regexpBin: /^4/ },
  ];

  private get cardThumb() {
    return this.validateBin(this.cardNumber);
  }

  public validateBin(cardNumber: string): string {
    const card = this.bins.find((bin) => bin.regexpBin.test(cardNumber));
    return card ? card.name : 'default';
  }
}
